/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { CoreNetworking } from '@airasia-rn/ui';
import EnvironmentURLs, { parseEnv } from '../util/EnvironmentURLs';
import { replaceComWithCn } from '../util/utils';
import type {
  FunnelControlRequest,
  FunnelControlResponse,
  FunnelHeadersInput,
} from '../types/FlightSearch.types';

export type Environment = 'stg' | 'prd';

export class FunnelControlApiService {
  constructor(
    private env: Environment,
    private geoId?: string,
  ) {}

  private getUrl(): string {
    return replaceComWithCn(
      this.geoId,
      EnvironmentURLs.FUNNEL_CONTROL[parseEnv(this.env)],
    );
  }

  async fetchFunnelControl(
    payload: FunnelControlRequest,
    headers: FunnelHeadersInput,
    signal?: AbortSignal,
  ): Promise<FunnelControlResponse> {
    try {
      const response = await CoreNetworking.post(this.getUrl(), payload, {
        signal,
        headers,
      });
      return response.data;
    } catch (err) {
      if (__DEV__) {
        console.log('❌ [FunnelControlApi] Fetch ERROR:', err);
      }
      throw err;
    }
  }
}
